import { render, staticRenderFns } from "./MintCompleted.vue?vue&type=template&id=0c41d302&scoped=true"
import script from "./MintCompleted.vue?vue&type=script&lang=js"
export * from "./MintCompleted.vue?vue&type=script&lang=js"
import style0 from "./MintCompleted.vue?vue&type=style&index=0&id=0c41d302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c41d302",
  null
  
)

export default component.exports